import React, { useState } from 'react'
import TitleBar from '../../Common/TitleBar'
import SidePanelTaskCreator from '../../Common/SidePanelTaskCreator'
import DashboardHeader from '../../Common/DashboardHeader'
import { ScrollPanel } from 'primereact/scrollpanel'
import DashboardFooter from '../../Common/DashboardFooter'
import SidePanelAdmin from '../../Common/SidePanelAdmin'
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { useDispatch } from 'react-redux'
import { fetchAdminUserActivatlistAction, onExportUserCsv } from '../../../Redux/Actions/AdminUserActivity'
import { FaSpinner } from 'react-icons/fa6'
import Pagination from '../../Common/Pagination'

const UserActivity = () => {
    const [isActive, setIsActive] = useState(true);
    const [activityData, setActivityData] = useState([])
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalItemOnPage: 20
    });
    const [loader, setLoader] = useState({
        fetch: false,
        export: false
    })
    const dispatch = useDispatch()
    const toggleClass = () => {
        setIsActive(!isActive);
    }
    const [date, setDate] = useState(null);

    const [typeId, setTypeId] = useState(null);
    const [byId, setById] = useState(null)
    const [selected, setSelected] = useState(null)
    const optionType = [
        { name: 'Login', code: '1' },
        { name: 'Joining Date', code: '2' },
        { name: 'Task Submission', code: '3' },

    ];
    const optionByAll = [
        { name: 'Is After', code: '2' },
        { name: 'Is Before', code: '3' },
        { name: 'On', code: '4' },



    ]
    const optionTag = [
        { name: 'Yes', code: '1' },
        { name: 'NO', code: '0' },
    ]

    // const optionBy = typeId?.code === "3" ? optionByAll.filter((item) => item.code !== "2" && item.code !== "3" && item.code !== "4") : optionByAll.filter((item) => item.code !== "1" && item.code !== "0")




    const handleSubmit = () => {
        let formData = {
            "type": typeId?.code,
            "on": byId?.code,
            "is_submitted": selected?.code,
            "date": date
        }
        setLoader({
            ...loader,
            fetch: true
        })
        dispatch(fetchAdminUserActivatlistAction("search-users-list", formData, setActivityData, setLoader, loader))

    }
    const handleCsvFileDownload = () => {
        if (!activityData || activityData.length === 0) {
            alert("No data available to export.");
            return;
        }

        setLoader((prev) => ({
            ...prev,
            export: true
        }));
        let csvContent = "number,first_name,last_name,company_name,email,tag,custom_field\n";

        activityData.forEach((user, index) => {

            let mobileNumber = user.mobileNumber ? user.mobileNumber.replace(/^\+91/, '') : '';
            let formattedMobile = `="${mobileNumber}"`;


            let name = user.name ? `"${user.name}"` : '""';
            let email = user.email ? `"${user.email}"` : '""';


            // let customFieldData = user.customField ? JSON.stringify(user.customField).replace(/"/g, '""') : '""';

            let row = `${formattedMobile},${name},"","vega6",${email},"member",{ "key": { "key1": "values1" } }`;
            csvContent += row + "\n";
        });


        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "UserActivity.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        setLoader(prev => ({ ...prev, export: false }));
    };

    const indexOfLastTodo = pagination.currentPage * pagination.totalItemOnPage;
    const indexOfFirstTodo = indexOfLastTodo - pagination.totalItemOnPage;
    const currentTodo = activityData.slice(indexOfFirstTodo, indexOfLastTodo)
    return (

        <>
            <TitleBar title="Activity user" />
            <div className="dashboard earnings_payouts container-fluid overflow-hidden">
                <div className="row">

                    <div className={`col-lg-2 col-md-3 col-sm-4 col-12 side-nav ${isActive ? "nav-show" : "nav-hide"}`}>
                        <SidePanelAdmin />
                    </div>
                    <div className={` p-0 ${isActive ? "col-lg-10 col-md-9 col-sm-8 col-12" : "col-12"} main-content`}>
                        <div>
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 ps-0 pe-0">
                                    <div className="dashboard-in main_task_wrapper">

                                        <DashboardHeader toggleSidebar={toggleClass} title="Activity" />
                                        <ScrollPanel className="custombar2 content-area pt-0" style={{ height: "100vh" }}>
                                            <div className="content-area-in tab-style">
                                                <div className='creator_new_task h-100'>
                                                    <div className='account-block'>
                                                        <div className='row'>
                                                            <div className='col-lg-3'>
                                                                <div className='submission_wrap submission_bg mb-4'>
                                                                    <lab for="" className="form-label mb-3">Type</lab>
                                                                    <Dropdown value={typeId} onChange={(e) => setTypeId(e.value)} options={optionType} optionLabel="name"
                                                                        placeholder="Select task type" className="w-full broder-0 " />
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-3'>
                                                                <div className='submission_wrap submission_bg mb-4'>
                                                                    <lab for="" className="form-label mb-3">By</lab>
                                                                    <Dropdown value={byId} onChange={(e) => setById(e.value)} options={optionByAll} optionLabel="name"
                                                                        placeholder="Select by" className="w-full broder-0 " />
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-3'>
                                                                <div className='submission_wrap submission_bg mb-4'>
                                                                    <lab for="" className="form-label mb-3">Is submited</lab>
                                                                    <Dropdown value={selected} onChange={(e) => setSelected(e.value)} options={optionTag} optionLabel="name"
                                                                        placeholder="Select Is submited" className="w-full broder-0 " />
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-3'>
                                                                <div className='submission_wrap submission_bg gap-1 placeholder-demo mb-4'>
                                                                    <lab for="" className="form-label mb-0">Select Date</lab>
                                                                    <Calendar placeholder='Date' value={date} onChange={(e) => setDate(e.value)} />

                                                                </div>
                                                            </div>

                                                            <div className='d-flex justify-content-end gap-2'>
                                                                <button className='theme-btn px-4 ' type="button" onClick={handleCsvFileDownload} disabled={activityData.length === 0} style={{ background: activityData.length === 0 ? "grey" : "", cursor: activityData.length === 0 ? "not-allowed" : "pointer" }}> {loader.export ? <>Exproting csv <FaSpinner className="spin ms-1" /></> : "Exprot csv"}</button>
                                                                <button className='theme-btn px-4' type="button" onClick={handleSubmit} disabled={!((byId && typeId))} style={{ background: !(byId && typeId) ? "grey" : "", cursor: !(byId && typeId) ? "not-allowed" : "pointer" }}>{loader.fetch ? <>Searching <FaSpinner className="spin ms-1" /></> : "Search"}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive position-relative earnings_table mt-1">
                                                        <table className="table theme-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.No</th>
                                                                    <th>Name</th>

                                                                    <th>Email</th>
                                                                    <th>Mobile No.</th>
                                                                </tr>
                                                            </thead>

                                                            <div className='d-flex align-items-center justify-content-center' style={{ width: "100%", position: "absolute" }}></div>
                                                            <tbody>
                                                                {currentTodo.length > 0 ? currentTodo.map((curElem, i) => {
                                                                    return (
                                                                        <tr key={i}>
                                                                            <td data-label="S.No">{i + 1}</td>
                                                                            <td data-label="User"><span className="userImg"><img src={curElem.profile ? curElem.profile : "https://images.pexels.com/photos/2169434/pexels-photo-2169434.jpeg"} alt="" /></span>{curElem.name}</td>

                                                                            <td data-label="Email">{curElem.email}</td>
                                                                            <td data-label="Mobile No.">{curElem.mobileNumber}</td>
                                                                        </tr>
                                                                    )
                                                                }) : <td className='text-center pt-3' colSpan={7}>No user data found</td>}

                                                            </tbody>

                                                        </table>
                                                    </div>
                                                    <Pagination
                                                        listData={activityData}
                                                        pagination={pagination}
                                                        setPagination={setPagination}
                                                        currentTodo={currentTodo}
                                                        listArr={activityData}
                                                        loader={loader.fetch}
                                                    />
                                                </div>
                                            </div>
                                        </ScrollPanel>
                                        <div className="d-none d-lg-block">
                                            <DashboardFooter />
                                        </div>
                                    </div>
                                </div>
                                <div className="d-block d-lg-none">
                                    <DashboardFooter />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default UserActivity
